import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SalesLetter() {
  return <section className="py-10 px-4 bg-[#111]" style={{
    paddingTop: '10px',
    paddingBottom: '10px'
  }} data-id="element-202">
      <div className="max-w-3xl mx-auto text-gray-300 leading-relaxed space-y-4" data-id="element-203">
        {/* Intro */}

        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-204">
          ¿Alguna vez te ha pasado esto?:
        </h2>

        <ul className="space-y-3" data-id="element-205">
          <li className="flex gap-3 items-start" data-id="element-206">
            <X className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-1" data-id="element-207" />
            <span className="text-gray-300" data-id="element-208">
              ¿Sientes que siempre fabricas{' '}
              <span className="font-bold text-white" data-id="element-209">las mismas piezas</span>{' '}
              porque no tienes diseños nuevos ni técnicas que te saquen del
              estancamiento?
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-210">
            <X className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-1" data-id="element-211" />
            <span className="text-gray-300" data-id="element-212">
              ¿Has{' '}
              <span className="font-bold text-white" data-id="element-213">
                desperdiciado barras de hierro completas
              </span>{' '}
              por trabajar "a ojo", sin medidas claras, y terminaste tirando
              tiempo y dinero a la basura?
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-214">
            <X className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-1" data-id="element-215" />
            <span className="text-gray-300" data-id="element-216">
              ¿Te da{' '}
              <span className="font-bold text-white" data-id="element-217">inseguridad cobrar</span>{' '}
              por tus trabajos porque no sabes cuánto valen realmente ni cuáles
              son los proyectos que los clientes están pidiendo HOY?
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-218">
            <X className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-1" data-id="element-219" />
            <span className="text-gray-300" data-id="element-220">
              ¿Te has sentido{' '}
              <span className="font-bold text-white italic" data-id="element-221">
                completamente perdido
              </span>{' '}
              al arrancar un proyecto nuevo porque nadie te dio un paso a paso
              profesional de principio a fin?
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-222">
            <X className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-1" data-id="element-223" />
            <span className="text-gray-300" data-id="element-224">
              ¿Has intentado copiar un mueble de Instagram o Pinterest{' '}
              <span className="font-bold text-white underline decoration-[#EF4444]/50" data-id="element-225">
                solo con una foto
              </span>
              ... y el resultado fue un desastre que no se parece en NADA al
              original?
            </span>
          </li>
        </ul>

        <p className="font-medium text-white text-lg mt-4" data-id="element-226">
          Estos son exactamente los mismos problemas que yo enfrenté cuando
          empecé en la herrería... y son los mismos desafíos que{' '}
          <span className="text-highlight" data-id="element-227">
            cientos de mis alumnos siguen enfrentando hoy.
          </span>
        </p>

        <div className="text-center py-4" data-id="element-228">
          <h3 className="text-3xl md:text-4xl font-oswald text-white uppercase leading-tight" data-id="element-229">
            "¡La herrería <span className="text-[#FF6B00]" data-id="element-230">NO</span> debería ser
            tan difícil!"
          </h3>
        </div>

        <div className="w-full px-5 box-border" data-id="element-231">
          <video autoPlay muted loop playsInline preload="auto" style={{
          width: '100%',
          height: 'auto',
          borderRadius: '22px',
          boxShadow: '0 0 28px rgba(255,120,0,0.28)',
          display: 'block',
          overflow: 'hidden'
        }} data-id="element-232">
            <source src="https://cdn.shopify.com/videos/c/o/v/ead673babfa846e1a92fabb7cb5f0a39.mp4" type="video/mp4" data-id="element-233" />
          </video>
        </div>

        <p className="text-lg" data-id="element-234">
          Si quieres crear los proyectos con los que siempre soñaste —{' '}
          <span className="font-bold text-white" data-id="element-235">rápido y sin vueltas</span>...
          en vez de pasar semanas adivinando medidas o gastar una fortuna
          pagándole a otro...
        </p>
        <p className="text-lg" data-id="element-236">
          Y anhelas esa satisfacción de crear algo impresionante con tus propias
          manos, algo que la gente mire y diga{' '}
          <span className="italic text-white" data-id="element-237">"¿Tú hiciste eso?"</span>...
        </p>
        <p className="font-bold text-[#FF6B00] text-xl border-l-4 border-[#FF6B00] pl-4 py-2 bg-[#FF6B00]/5" data-id="element-238">
          Entonces esta puede ser la página más importante que leas en tu vida.
        </p>

        {/* The Problem */}
        <div className="pt-6" data-id="element-239">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-240">
            "Este Es El{' '}
            <span className="text-[#EF4444] underline decoration-2 underline-offset-4" data-id="element-241">
              GRAN Problema
            </span>
            ..."
          </h3>
          <p className="mb-4 font-bold text-white bg-red-900/20 p-4 border border-red-900/50 rounded text-center text-lg" data-id="element-242">
            La mayoría de los métodos para aprender herrería son{' '}
            <span className="text-[#EF4444] uppercase" data-id="element-243">BASURA COMPLETA.</span>
          </p>

          <div className="space-y-3 mb-5" data-id="element-244">
            <div className="bg-[#1a1a1a] p-4 rounded border border-[#333] hover:border-[#EF4444]/30 transition-colors" data-id="element-245">
              <span className="text-[#EF4444] font-bold text-lg block mb-1" data-id="element-246">
                El "ensayo y error":
              </span>{' '}
              Te hace perder{' '}
              <span className="text-white font-medium" data-id="element-247">
                meses y cientos de dólares
              </span>{' '}
              aprendiendo a golpes lo que podrías aprender en un día con el
              plano correcto.
            </div>
            <div className="bg-[#1a1a1a] p-4 rounded border border-[#333] hover:border-[#EF4444]/30 transition-colors" data-id="element-248">
              <span className="text-[#EF4444] font-bold text-lg block mb-1" data-id="element-249">
                Copiar fotos de Pinterest/Instagram:
              </span>{' '}
              Una imagen bonita con{' '}
              <span className="text-white font-medium" data-id="element-250">
                CERO medidas, CERO lista de materiales.
              </span>{' '}
              Te esperan a que adivines y reces.
            </div>
            <div className="bg-[#1a1a1a] p-4 rounded border border-[#333] hover:border-[#EF4444]/30 transition-colors" data-id="element-251">
              <span className="text-[#EF4444] font-bold text-lg block mb-1" data-id="element-252">
                Los cursos puramente teóricos:
              </span>{' '}
              Horas de "tipos de soldadura" y "teoría del metal"... pero{' '}
              <span className="text-white font-medium" data-id="element-253">
                NUNCA te enseñan a fabricar una pieza REAL
              </span>{' '}
              que puedas VENDER.
            </div>
            <div className="bg-[#1a1a1a] p-4 rounded border border-[#333] hover:border-[#EF4444]/30 transition-colors" data-id="element-254">
              <span className="text-[#EF4444] font-bold text-lg block mb-1" data-id="element-255">
                Los planos genéricos sueltos:
              </span>{' '}
              Les faltan medidas, o asumen que sos un profesional con un taller
              de $10,000 dólares.
            </div>
          </div>

          <p className="font-bold text-white text-center text-xl leading-relaxed" data-id="element-256">
            Estos supuestos "métodos" hacen que la herrería parezca{' '}
            <span className="text-highlight" data-id="element-257">MÁS DIFÍCIL</span> de lo que
            realmente es.{' '}
            <span className="italic text-gray-400 block mt-2 font-normal" data-id="element-258">
              ¡Con razón tanta gente abandona!
            </span>
          </p>
        </div>

        {/* The Solution */}
        <div className="pt-12" style={{
        paddingTop: '10px',
        paddingBottom: '10px'
      }} data-id="element-259">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-260">
            Decidí Resolver Todo Eso...
          </h3>

          <div className="mb-5" data-id="element-261">
            <img src="https://cdn.magicpatterns.com/uploads/ipabubcqup3VguZeNaEoHE/ChatGPT_Image_20_ene_2026,_08_46_52_p.m._(1).png" alt="Proyectos de herrería industrial — Estanterías, escritorios, racks, armarios y más" className="w-full h-auto rounded-lg shadow-[0_0_30px_rgba(0,0,0,0.6)]" data-id="element-262" />
          </div>

          <p className="mb-4 text-lg" data-id="element-263">
            Esos problemas se convirtieron en una bendición disfrazada. Porque
            invertí años compilando y perfeccionando{' '}
            <span className="font-bold text-white" data-id="element-264">
              la colección más completa de planos metálicos
            </span>{' '}
            con medidas exactas para fabricar muebles industriales que se venden
            como pan caliente.
          </p>

          <div className="bg-[#FF6B00]/10 border border-[#FF6B00] p-5 md:p-6 rounded-lg text-center shadow-[0_0_30px_rgba(255,107,0,0.1)]" data-id="element-265">
            <p className="text-xl font-medium text-white mb-3 leading-relaxed" data-id="element-266">
              ¿Qué dirías si te digo que podés tener{' '}
              <span className="text-highlight-full" data-id="element-267">
                más de 600 planos metálicos
              </span>{' '}
              "listos para fabricar" con medidas exactas, lista de materiales e
              instrucciones paso a paso...
            </p>
            <p className="font-bold text-[#FF6B00] text-2xl uppercase" data-id="element-268">
              ...para que construyas piezas profesionales — fácil, rápido y sin
              dolores de cabeza?
            </p>
          </div>
        </div>

        <div className="text-center py-10" style={{
        paddingTop: '0px',
        paddingBottom: '0px'
      }} data-id="element-269">
          <p className="text-sm uppercase tracking-[0.2em] text-gray-500 mb-2 font-bold" data-id="element-270">
            PRESENTAMOS...
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/ijfnPMf2L9ZoDp86PhZZ8a/ChatGPT_Image_20_ene_2026,_06_40_17_p.m._(1).png" alt="Sistema Maestro de Herrería — Sistema Listo Para Fabricar, Mapa Maestro del Taller, Motor de Presupuestos Profesionales" className="w-full max-w-2xl mx-auto h-auto mb-4" data-id="element-271" />
          <h2 className="text-5xl md:text-6xl font-oswald text-white mb-3 tracking-tight" style={{
          fontSize: '28px'
        }} data-id="element-272">
            SISTEMA MAESTRO DE HERRERÍA
          </h2>
          <p className="text-xl md:text-2xl text-white font-medium mb-4 bg-[#1a1a1a] inline-block px-4 py-2 rounded border border-[#333]" data-id="element-273">
            "La Base de Datos Más Completa de Planos Metálicos Industriales"
          </p>
          <p className="text-gray-300 max-w-xl mx-auto mb-2 text-lg" data-id="element-274">
            Fabricá <span className="font-bold text-white" data-id="element-275">+600 proyectos</span>{' '}
            con planos paso a paso y medidas exactas... incluso si no tenés un
            taller enorme ni herramientas costosas.
          </p>
          <p className="text-gray-400 max-w-xl mx-auto mb-3 italic" data-id="element-276">
            ¿Qué hace que un plano de herrería sea "perfecto"? Mirá por qué
            nuestros planos son{' '}
            <span className="text-white font-bold not-italic underline decoration-[#FF6B00]" data-id="element-277">
              10 veces mejores
            </span>{' '}
            que todo lo que encontrás suelto por ahí:
          </p>
        </div>
      </div>
    </section>;
}